module.exports = __webpack_public_path__ + "static/logoOne-cdad94beb5d30cd600318e1d8c7bbbd5.png";